<template>
	<div class="close-arrow">
		<svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none">
			<path
				d="M1.70697 23.707L0.292969 22.293L10.5855 12L0.292969 1.70697L1.70697 0.292969L13.4145 12L1.70697 23.707Z"
				fill="black" />
		</svg>
	</div>
</template>

<script>
export default {
	name: "close-arrow-icon",
};
</script>
